import {fetchJSON} from './Backend'
import {STATUS_SERVER_ERROR } from 'totalinvoice-frontend-core'

export async function getCustomerCheckErrors(customer,language){
  let res =  await fetchJSON("customer/check/"+language,customer);
  let errorData = {}
  if (res.status === "ok") {
    //OK  {"status":"ok","errorCode":null,"message":null,"data":{"customer":{"errors":null,"status":"OK"}}}
    //error {"status":"ok","errorCode":null,"message":null,"data":{"customer":{"errors":[{"error":-8,"field":"vatno","errordesc":"Invalid VAT number 'DE12345678'"}],"status":"KO"}}}
    if(res.data && res.data.customer && res.data.customer.status && res.data.customer.status != "OK"){
      res.data.customer.errors.forEach(error => {
        errorData[error.field] = error.errordesc
      });
     
    }
    
  } else{
    return STATUS_SERVER_ERROR
  }

  return errorData
}